import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datefr',
    standalone: false
})
export class DatefrPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if (value && typeof value === 'string') {
      const tab1 = value.split('T');
      value = tab1[0];
      const tab = value.split('-');
      if (tab.length === 3) {
        return tab[2] + '/' + tab[1] + '/' + tab[0];
      }
    }
    return value;
  }

}
